import { clx } from '@medusajs/ui';
import type { ReactNode } from 'react';

export const Heading = ({
  type,
  children,
}: {
  type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  children: ReactNode;
}) => {
  const Tag = type;
  return (
    <Tag className={clx('text-black-20 mt-2', `rich-text-${type}`)}>
      {children}
    </Tag>
  );
};
